import _ from 'underscore';
import Backbone from 'backbone';

// http://lostechies.com/derickbailey/2012/04/03/revisiting-the-backbone-event-aggregator-lessons-learned/
export default _.extend({}, Backbone.Events, { cid: 'dispatcher' });
